const STORAGE_KEY = 'brevo_visitor_id';

// Persistent anonymous identifier for events fired before any booking exists
// (e.g. phone_cta_clicked) — new-ibe has no other visitor-tracking mechanism.
export const getVisitorId = () => {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = `visitor-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch (e) {
    return undefined;
  }
};
